import * as React from 'react'

import { compact } from 'lodash'

import DatePickerFilter from 'modules/core/components/Filter/filters/DatePicker'
import { type Props as DatePickerProps } from 'modules/core/components/Filter/filters/DatePicker'
import { dateToString, stringToDate } from 'modules/core/lib/dates'

type SingleValue = string | undefined
type RangeValue = [string | undefined, string | undefined]
type AllValues = SingleValue | RangeValue

export default function DateTimePickerFilter(props: DatePickerProps) {
  const { onValueChange, mode } = props

  const onRangeValueChange = (newValue: AllValues) => {
    const [firstDate, secondDate] = (newValue as RangeValue) ?? []

    const firstDateMoment = firstDate ? stringToDate(firstDate, 'backend') : undefined
    const secondDateMoment = secondDate ? stringToDate(secondDate, 'backend') : undefined

    const firstDateValue = firstDateMoment?.isValid()
      ? dateToString(firstDateMoment, 'backend_datetime')
      : undefined
    const secondDateValue = secondDateMoment?.isValid()
      ? dateToString(secondDateMoment.endOf('day'), 'backend_datetime')
      : undefined

    onValueChange(compact([firstDateValue, secondDateValue]) as string & RangeValue)
  }

  const onSingleValueChange = (newDate: AllValues) => {
    const newMoment = stringToDate(newDate as string, 'backend')
    const newDateValue = newMoment.isValid()
      ? dateToString(newMoment, 'backend_datetime')
      : undefined
    onValueChange(newDateValue as string & RangeValue)
  }

  return (
    <DatePickerFilter
      {...props}
      onValueChange={mode === 'range' ? onRangeValueChange : onSingleValueChange}
    />
  )
}
